<template>
  <div class>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="电桩充电告警" name="charge" permission="alarm.equipment.charge">
        <STable
          ref="chargeTableref"
          :url="chargeUrl"
          :columns="chargeColumns"
          :handles="chargeHandles"
          :query="chargeQuery"
          :toolbar="chargeToolbar"
          :selection="false"
          :is-alarm="true"
          label-width="100px"
        />
      </el-tab-pane>
      <el-tab-pane label="电桩离线告警" name="offLine" permission="alarm.equipment.offline">
        <STable
          ref="offLineTableref"
          :url="offLineUrl"
          :columns="offLineColumns"
          :query="offLineQuery"
          :toolbar="offLineToolbar"
          :selection="false"
          :is-alarm="true"
          label-width="100px"
        />
      </el-tab-pane>
      <el-tab-pane label="电桩故障告警" name="fault" permission="alarm.equipment.fault">
        <STable
          ref="faultTableref"
          :url="faultUrl"
          :columns="faultColumns"
          :handles="faultHandles"
          :query="faultQuery"
          :toolbar="faultToolbar"
          :selection="false"
          :is-alarm="true"
          label-width="100px"
        />
      </el-tab-pane>
            <el-tab-pane label="异常停充告警" name="stop" permission="alarm.equipment.fault">
        <STable
          ref="stopTableref"
          :url="stoptUrl"
          :columns="stopColumns"
          :query="stopQuery"
          :toolbar="stopToolbar"
          :selection="false"
          :is-alarm="true"
          label-width="100px"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
import fieldFilter from '@/utils/fieldFilter.js'
import { TreeDataNull } from '@/utils/tool.js'
export default {
  name: 'Dianzhuanganquangaojing',
  components: {},
  data() {
    return {
      activeName: 'charge',
      // isCharge: false,
      // isOffLine: false,
      // isFault: false,
      chargeUrl: '/alarm/alarmRecord/pageEquipmentCharge',
      chargeColumns: [
        {
          label: '终端名称',
          prop: 'connectorName'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel'
        },
        {
          label: '终端编码',
          prop: 'connectorID'
        },
        {
          label: '归属电站',
          prop: 'stationName'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '告警等级',
          prop: 'alarmLevel'
        },
        {
          label: '告警时间',
          prop: 'createDate'
        },
        {
          label: '短信',
          prop: 'isSendSMS',
          template: (index, record) => {
            return record.isSendSMS ? '是' : '否'
          }
        },
        {
          label: '停充',
          prop: 'isStopCharging',
          template: (index, record) => {
            return record.isStopCharging ? '是' : '否'
          }
        },
        {
          label: '告警原因',
          prop: 'alarmType'
        }
      ],
      // 操作栏
      chargeHandles: {
        width: 80,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'alarm.equipment.charge.details',
            handle: resp => {
              this.$router.push({ path: './pileSafetyAlarmDetail', query: { data: resp.id }})
            }
          }
        ]
      },
      chargeQuery: [
        {
          label: '终端名称',
          prop: 'connectorName',
          placeholder: '请输入终端名称 '
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel',
          type: 'cascader',
          data: [],
          props: {
            label: 'name',
            value: 'name',
            checkStrictly: true
          },
          placeholder: '请选择品牌型号'
        },
        {
          label: '终端编码',
          prop: 'connectorID',
          placeholder: '请输入终端编码'
        },
        {
          label: '归属电站',
          prop: 'stationName',
          placeholder: '请输入归属电站'
        },
        {
          label: '充电单号',
          prop: 'startChargeSeq',
          placeholder: '请输入充电单号'
        },
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '告警等级',
          prop: 'alarmLevel',
          placeholder: '请选择告警等级',
          type: 'select',
          data: [
            {
              label: '一级',
              value: 1
            },
            {
              label: '二级',
              value: 2
            },
            {
              label: '三级',
              value: 3
            }
          ]
        },
        {
          label: '告警原因',
          prop: 'alarmType',
          placeholder: '请选择告警原因',
          type: 'select',
          data: [
            {
              label: '枪线温度过高',
              value: '0'
            },
            {
              label: '枪线温度过低',
              value: '1'
            },
            {
              label: '充电电压过高',
              value: '2'
            },
            {
              label: '充电电压过低',
              value: '3'
            },
            {
              label: '充电电流过高',
              value: '4'
            },
            {
              label: '充电电流过低',
              value: '5'
            },
            {
              label: '输出功率不足',
              value: '6'
            }
          ]
        },
        {
          label: '短信通知',
          prop: 'isSendSMS',
          placeholder: '请选择短信通知',
          type: 'select',
          data: [
            {
              label: '是',
              value: 0
            },
            {
              label: '否',
              value: 1
            }
          ]
        },
        {
          label: '是否停充',
          prop: 'isStopCharging',
          placeholder: '请选择是否停充',
          type: 'select',
          data: [
            {
              label: '是',
              value: 0
            },
            {
              label: '否',
              value: 1
            }
          ]
        },
        {
          label: '告警时间',
          prop: 'startDateTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      chargeToolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          permission: 'alarm.equipment.charge.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/alarm/alarmRecord/pageEquipmentCharge?isExport=true'
            const queryData = this.$refs.chargeTableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'get',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ],

      // 离线告警
      offLineUrl: '/alarm/alarmRecord/pageEquipmentOffLine',
      offLineColumns: [
        {
          label: '终端名称',
          prop: 'connectorName'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel'
        },
        {
          label: '终端编码',
          prop: 'connectorID'
        },
        {
          label: '归属电站',
          prop: 'stationName'
        },
        {
          label: '运营商',
          prop: 'operatorName'
        },
        {
          label: '离线发生时间',
          prop: 'createDate'
        },
        {
          label: "异常变位状态",
          prop: "changeState"
        },
        {
          label: '离线恢复时间',
          prop: 'recoveryTime'
        },
        // {
        //   label: "恢复变位状态",
        //   prop: "",
        // },
        {
          label: '异常状态',
          prop: 'abnormalState'
        },
        {
          label: '离线时长(分钟)',
          prop: 'duration',
          template: (index, record) => {
            return record.duration ? (record.duration).toFixed(0) : ''
          }
        }
      ],
      // 操作栏
      offLineHandles: {
        width: 80,
        btns: [
          {
            label: '详情',
            permission: 'alarm.equipment.offline.details',
            handle: resp => {
              this.$router.push({ path: './pileOffLineAlarmDetail', query: { data: resp.id }})
            }
          }
        ]
      },
      offLineQuery: [
        {
          label: '离线发生时间',
          prop: 'createStartDateTime',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '终端编码',
          prop: 'connectorID',
          placeholder: '请输入终端编码'
        },
        {
          label: '终端名称',
          prop: 'connectorName',
          placeholder: '请输入终端名称'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel',
          type: 'cascader',
          data: [],
          props: {
            label: 'name',
            value: 'name',
            checkStrictly: true
          },
          placeholder: '请选择品牌型号'
        },
        {
          label: '运营商',
          prop: 'operatorCode',
          placeholder: '请输入运营商'
        },
        {
          label: '充电站',
          prop: 'stationName',
          placeholder: '请输入充电站'
        },
        {
          label: '离线恢复时间',
          prop: 'recoveryStartDateTime',
          placeholder: '',
          type: 'date2'
        },
        // {
        //   label: "异常变位状态",
        //   prop: "changeState",
        //   placeholder: "请选择异常变位状态",
        //   type: "select",
        //   data: [
        //     {
        //       label: "故障->离线",
        //       value: 0
        //     },
        //     {
        //       label: "空闲->离线",
        //       value: 1
        //     },
        //     {
        //       label: "充电->离线",
        //       value: 2
        //     },
        //     {
        //       label: "占用->离线",
        //       value: 3
        //     },
        //   ]
        // },
        // {
        //   label: "恢复变位状态",
        //   prop: "recoverState",
        //   placeholder: "请选择恢复变位状态",
        //   type: "select",
        //   data: [
        //     {
        //       label: "离线->故障",
        //       value: 0
        //     },
        //     {
        //       label: "离线->空闲",
        //       value: 1
        //     },
        //     {
        //       label: "离线->充电",
        //       value: 2
        //     },
        //     {
        //       label: "离线->占用",
        //       value: 3
        //     },
        //   ]
        // },
        {
          label: '离线时长',
          type: 'scopeBox',
          prop: 'scopeBox',
          placeholder: '',
          middleLabel: '-',
          minProp: 'startOffLineTime',
          maxProp: 'endOffLineTime',
          unit: '分钟',
          width: '20px'
        },
        {
          label: '异常状态',
          prop: 'abnormalState',
          placeholder: '请选择异常状态',
          type: 'select',
          data: [
            {
              label: '全部',
              value: 0
            },
            {
              label: '未恢复',
              value: 1
            },
            {
              label: '已恢复',
              value: 2
            }
          ]
        }
      ],
      offLineToolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          permission: 'alarm.equipment.offline.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/alarm/alarmRecord/pageEquipmentOffLine?isExport=true'
            const queryData = this.$refs.offLineTableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'get',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ],

      // 故障告警
      faultUrl: '/alarm/alarmRecord/pageEquipmentFault',
      faultColumns: [
        {
          label: '终端名称',
          prop: 'connectorName'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel'
        },
        {
          label: '终端编码',
          prop: 'connectorID'
        },
        {
          label: '归属电站',
          prop: 'stationName'
        },
        {
          label: '告警时间',
          prop: 'createDate'
        },
        {
          label: '变位状态',
          prop: 'changeState'
        },
        {
          label: '告警码',
          prop: 'alarmCode'
        },
        {
          label: '告警事项',
          prop: 'alarmName'
        }
      ],
      // 操作栏
      faultHandles: {
        width: 80,
        btns: [
          {
            label: '详情',
            permission: 'alarm.equipment.fault.details',
            handle: resp => {
              this.$router.push({ path: './pileFaultAlarmDetail', query: { data: resp.id }})
            }
          }
        ]
      },
      faultQuery: [
        {
          label: '终端名称',
          prop: 'connectorName',
          placeholder: '请输入终端名称'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel',
          type: 'cascader',
          data: [],
          props: {
            label: 'name',
            value: 'name',
            checkStrictly: true
          },
          placeholder: '请选择品牌型号'
        },
        {
          label: '终端编码',
          prop: 'connectorID',
          placeholder: '请输入终端编码'
        },
        {
          label: '归属电站',
          prop: 'stationName',
          placeholder: '请输入归属电站'
        },
        {
          label: '告警码',
          prop: 'alarmCode',
          placeholder: '请输入告警码'
        },
        {
          label: '告警事项',
          prop: 'alarmMatter',
          placeholder: '请输入告警事项'
        },
        {
          label: '告警时间',
          prop: 'startDateTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      faultToolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          permission: 'alarm.equipment.fault.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/alarm/alarmRecord/pageEquipmentFault?isExport=true'
            const queryData = this.$refs.faultTableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'get',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ],
            // 异常告警
      stoptUrl: '/alarm/alarmRecord/pageStopChargeFault',
      stopColumns: [
                {
          label: '充电订单',
          prop: 'startChargeSeq'
        },
        {
          label: '终端编码',
          prop: 'connectorID'
        },
        {
          label: '品牌型号',
          prop: 'equipmentModel'
        },
        {
          label: '归属电站',
          prop: 'stationName'
        },
                {
          label: '订单结束原因',
          prop: 'alarmName'
        },
        {
          label: '告警时间',
          prop: 'createDate'
        },
      ],
      // 操作栏
      stopQuery: [
        {
          label: '终端编码',
          prop: 'connectorID',
          placeholder: '请输入终端编码'
        },
                {
          label: '品牌型号',
          prop: 'equipmentModel',
          type: 'cascader',
          data: [],
          props: {
            label: 'name',
            value: 'name',
            checkStrictly: true
          },
          placeholder: '请选择品牌型号'
        },
                {
          label: '告警时间',
          prop: 'startDateTime',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '归属电站',
          prop: 'stationName',
          placeholder: '请输入归属电站'
        },
      ],
      stopToolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          permission: 'alarm.equipment.fault.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/alarm/alarmRecord/pageStopChargeFault?isExport=true'
            const queryData = this.$refs.stopTableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'get',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]

    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.$store.dispatch('form/handle', {
      url: '/station/equipment/getBrandTree',
      method: 'get',
      callback: (resp) => {
        if (resp && resp.length > 0) {
          this.chargeQuery[1].data = TreeDataNull(resp)
          this.offLineQuery[3].data = TreeDataNull(resp)
          this.faultQuery[1].data = TreeDataNull(resp)
          this.stopQuery[1].data = TreeDataNull(resp)
        }
      }
    })
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/pileSafetyAlarm.vue